import { render } from "./DefaultPostSectionNewsCmp.vue?vue&type=template&id=5304f3f6"
import script from "./DefaultPostSectionNewsCmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostSectionNewsCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__